import React from 'react';
import _ from 'lodash';

import { SPOT_WORKER_TAB } from '../../../utilities/constants';

/**
 * @props {number} selectedTabId 選択中のタブのID
 * @props {function} onTabClick タブをクリックした時の処理
 * @props {bool} othersDisabled
 */
export const SpotWorkerTab = props => {
  if (_.isUndefined(props.selectedTabId)) {
    throw new Error('props.selectedTabId is undefined');
  }

  if (!_.isFunction(props.onTabClick)) {
    throw new Error('props.onTabClick is not a function');
  }

  return (
    <ul className='contruction-navi-list'>
      {_.map(SPOT_WORKER_TAB, item => {
        const isTabSelected = props.selectedTabId === item.ID;
        const isTabDisabled = props.othersDisabled && !isTabSelected;
        return (
          <li
            className={`contruction-navi-list__item ${isTabDisabled &&
              'disabled'}`}
            key={item.ID}
          >
            <a
              key={`${String(item.ID)}_a`}
              onClick={() => props.onTabClick(item.ID)}
              className={`line-list line-list--contruction-navi-list ${isTabSelected &&
                'select'} ${isTabDisabled && 'disabled'}`}
            >
              <div className='line-list--contruction-navi-value'>
                <span className='tab-label'>{`${item.NAME}`}</span>
              </div>
            </a>
          </li>
        );
      })}
    </ul>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/tab/SpotWorkerTab.jsx